import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ViewContainerRef,
} from "@angular/core";
import esriConfig from "@arcgis/core/config";
import MapView from "@arcgis/core/views/MapView";
import Map from "@arcgis/core/Map";
import WebMap from "@arcgis/core/WebMap";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ModalWorkspaceComponent } from "../../../home/components/modal-workspace/modal-workspace.component";
import { PanoramicService } from "../../services/panoramic.service";
import { MapService } from "../../services/map.service";
import { FilterComponent } from "../../../home/components/filter/filter.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import Point from "@arcgis/core/geometry/Point";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";
import { environment } from "../../../../environments/environment";
import { HomeBarComponent } from "../../../widgets/home-bar/home-bar.component";
import { WidgetDirective } from "../../../widgets/directiva/directive-widget.directive";
import WebTileLayer from "@arcgis/core/layers/WebTileLayer.js";
import GeoJSONLayer from "@arcgis/core/layers/GeoJSONLayer.js";

@Component({
  selector: "app-view-map",
  templateUrl: "./map-view.component.html",
  styleUrls: ["./map-view.component.css"],
})
export class MapViewComponent implements OnInit {
  public view: any = null;
  measureLineActive = false;
  measurePolygonActive = false;
  idMap = environment.mapId;
  urlPortal = environment.portalUrl;
  view360 = environment.modules.view360;
  apiKey = environment.apiKeyArcGIS;
  mapReady: boolean = false;
  @ViewChild("map", { static: true }) private mapViewEl!: ElementRef;
  @ViewChild(WidgetDirective, { static: true })
  private appDirectiveWidget!: WidgetDirective;

  constructor(
    protected dialog: MatDialog,
    protected panoramicService: PanoramicService,
    private _snackBar: MatSnackBar,
    protected mapService: MapService,
    protected viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.chargeMap().then(() => {
      this.addWidgets();
      //this hides hotspot layer from the layer list
      const hotSpotLayer = this.view.map.allLayers.find(function (layer) {
        return layer.title.toLowerCase().includes("hotspot");
      });
      if (hotSpotLayer) {
        hotSpotLayer.listMode = "hide";
      }
    });
  }

  ngOnDestroy() {
    document.getElementById("coordenadas").innerHTML = "";
    document.getElementById("scaleBar").innerHTML = "";
  }

  chargeMap(): Promise<any> {
    const container = this.mapViewEl.nativeElement;

    const upllayer = new GeoJSONLayer({
      url: "./assets/layers/upl.geojson",
      visible: false,
      title: "Unidad de Planeamiento Local",
    });

    const map = new Map({
      layers: [upllayer],
      basemap: "streets-vector",
    });

    // const webmap = new WebMap({
    //   portalItem: {
    //     id: this.idMap,
    //   },
    // });

    const viewMap = new MapView({
      map: map,
      container: container,
      center: [-74.08175, 4.60971],
      zoom: 10,
    });

    // viewMap.on("pointer-move", function (event) {
    //   const point: Point = viewMap.toMap({
    //     x: event.x,
    //     y: event.y,
    //   });
    //   document.getElementById("coordenadas").innerHTML =
    //     point.latitude.toFixed(5) + " , " + point.longitude.toFixed(5);
    // });
    this.view = viewMap;
    this.mapService.setViewMap(this.view);
    //this removes the default zoom controllers
    this.view.ui.remove("zoom");
    return this.view.when();
  }

  addWidgets() {
    new ScaleBar({
      view: this.view,
      container: "scaleBar",
      unit: "metric",
    });

    this.appDirectiveWidget = new WidgetDirective(this.viewContainer);
    const elementDom =
      this.appDirectiveWidget.viewContainerRef.createComponent(
        HomeBarComponent
      );
    this.view.ui.add(elementDom.location.nativeElement, "bottom-right");
    this.view.popup.dockEnabled = true;
  }

  openWorkspace() {
    this.dialog.open(ModalWorkspaceComponent, { data: {} });
  }

  openFilter() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.closeOnNavigation = false;
    if (this.panoramicService.getPanoramic()) {
      this.dialog.open(FilterComponent, dialogConfig);
    } else {
      this._snackBar.open("Active la vista mixta para buscar activos", "", {
        duration: 1000,
        horizontalPosition: "center",
        verticalPosition: "top",
      });
    }
  }
}
